import { createFileRoute, Outlet } from '@tanstack/react-router'
import { PersonalCreditsPage } from '@/features/account/pages/credits/personal-credits-page'
import { useAccountWorkspace } from '@/features/account/workspace-context'

/**
 * Credits section layout — D1 overview · D2 caps ("Limits") · D3 allocation ·
 * D4 usage.
 *
 * DS v3 folds the four into a single screen, so the tab strip moved *into* the
 * pages: it sits under each panel's own head, and those heads differ (Overview
 * carries a description, Usage a period filter), which a layout route above the
 * outlet cannot express. The routes are unchanged so deep links, back/forward
 * and the e2e specs keep working; this layout is now just the outlet. The strip
 * lives in `features/account/pages/credits/components/credits-tabs.tsx`.
 */
export const Route = createFileRoute('/_ws/w/$workspaceId/credits')({
  component: CreditsLayout,
})

function CreditsLayout() {
  const { isAdmin, isOwner } = useAccountWorkspace()
  return isAdmin || isOwner ? <Outlet /> : <PersonalCreditsPage />
}
